import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import BlacklistContainer from '../components/BlacklistContainer';
import { BlacklistManagementProvider } from '../context/BlacklistManagement';

const Blacklist = lazy(
  () => import('../components/BlackList/BlackList')
);

const ChannelWiseBlacklist = lazy(
  () => import('../../ChannelWiseBlacklist/components/ChannelWiseBlacklist')
);

const EditBlacklistManagement = lazy(
  () => import('../components/EditBlacklist/EditBlacklist')
);

const WebhookManager = lazy(
  () => import('../components/WebhookManager/WebhookManager')
);

const BlacklistConfigRoute: RouteObject[] = [
  {
    path: '/settings/blacklist',
    element: <BlacklistContainer />,
    children: [
      {
        index: true,
        element: <ChannelWiseBlacklist />,
      },
      {
        path: 'loyalty',
        element: <Blacklist />,
      },
      {
        path: 'webhooks',
        element: <WebhookManager />,
      },
    ],
  },
  {
    path: '/settings/blacklist/loyalty/:id',
    element: (
      <BlacklistManagementProvider>
        <EditBlacklistManagement />
      </BlacklistManagementProvider>
    ),
  },
];

export default BlacklistConfigRoute;
